import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=2012ca82&"
import script from "./InvoiceDetail.js?vue&type=script&lang=js&"
export * from "./InvoiceDetail.js?vue&type=script&lang=js&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports